import type { ConsentOrigin } from "./SetupContext.tsx";
import { useMemo } from "react";
import { useLocation } from "react-router";
import { buildSetupRedirectUrl } from "./setupRedirect.ts";
import { useTenantAssessmentPaths } from "./useTenantAssessmentPaths.ts";

export function useGetSetupUrl(origin: ConsentOrigin) {
    const { setup } = useTenantAssessmentPaths();
    const location = useLocation();

    return useMemo(() => {
        const returnTo = `${location.pathname}${location.search}`;

        return buildSetupRedirectUrl(setup, origin, returnTo);
    }, [setup, origin, location.pathname, location.search]);
}
